import TeacherAgreementFooter from './TeacherAgreementFooter';
import { TeacherAgreementFooterProps, TeacherAgreementFooterValueProps } from './types';

export type { TeacherAgreementFooterProps, TeacherAgreementFooterValueProps };
export default TeacherAgreementFooter;
